// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <detail-view
  :endpoint="endpoint + 'ssosettings'"
  name="SSO Settings"
  parentRoute="images"
  permissions="ssosettings"
  :values="values"
  noPathId
  ></detail-view>
</template>
<script>
import {ENDPOINT} from '@/shared/constants'
import DetailView from '@sdgsystems/vue-common/components/DetailView.vue'

export default {
  components: {
    DetailView
  },

  data () {
    return {
      endpoint: ENDPOINT,
      values: [
        {
          name: 'Okta',
          items: [
            [
              {
                name: 'Okta Issuer',
                value: 'oktaIssuer'
              },
              {
                name: 'Okta Client ID',
                value: 'oktaClientId'
              },
              {
                name: 'Okta Secret',
                value: 'oktaClientSecret'
              }
            ]
          ]
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// OrgSSOSettingsEdit.vue?91961b46